export default "__VITE_ASSET__BQ4I0Jua__"